module.exports = __webpack_public_path__ + "img/title.5ee5b6da.png";